import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

// When a user reaches a task page via a "Review" link inside the Month-End Close
// window, this hook auto-returns them to that close window as soon as the task is
// resolved (its outstanding count drops to zero). `ctx` is the close period id, or
// "new" for the New close period dialog.
export function useReturnToClose(resolved, ready, enabled = true) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ctx = params.get("fromClose");
  const armed = useRef(false);

  useEffect(() => {
    if (!enabled || !ctx || !ready) return;
    if (!resolved) { armed.current = true; return; }
    if (resolved && armed.current) {
      armed.current = false;
      toast.success("All done — back to Month-End Close");
      navigate(ctx === "new" ? "/close?newclose=1" : `/close?open=${ctx}`);
    }
  }, [enabled, ctx, ready, resolved, navigate]);
}
